import { Component } from 'react';
import ContactUs from './contact-us';


export default class ContactUsComponent extends Component {
    render() {
        return <div>
            <ContactUs></ContactUs>
        </div>
    }
}